import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';

export type SideNavigationOptionUi = {
  id: string;
  to: string;
  icon?: React.ReactNode;
  label: string;
  children: SideNavigationOptionUi[];
  expanded?: boolean;
};

export const ADMIN_MENU_OPTIONS: SideNavigationOptionUi[] = [
  {
    id: 'buyer',
    to: '/admin/buyer',
    icon: <ShoppingBagOutlinedIcon />,
    label: 'Compradores',
    children: [],
  },
  {
    id: 'seller',
    to: '/admin/seller',
    icon: <StorefrontOutlinedIcon />,
    label: 'Vendedores',
    children: [],
  },
  {
    id: 'products',
    to: '/admin/products',
    icon: <CategoryOutlinedIcon />,
    label: 'Productos',
    children: [],
  },
  {
    id: 'orders',
    to: '/admin/orders',
    icon: <ReceiptLongOutlinedIcon />,
    label: 'Pedidos',
    children: [],
  },
  {
    id: 'carts',
    to: '/admin/carts',
    icon: <ShoppingCartOutlinedIcon />,
    label: 'Carritos',
    children: [],
  },
  {
    id: 'payment-balance',
    to: '/admin/payments-and-balance',
    icon: <BalanceOutlinedIcon />,
    label: 'Pagos y Balances',
    children: [],
  },
];

export const SELLER_MENU_OPTIONS: SideNavigationOptionUi[] = [
  {
    id: 'orders',
    to: '/seller/orders',
    icon: <ReceiptLongOutlinedIcon />,
    label: 'Pedidos',
    children: [],
  },
  {
    id: 'products',
    to: '/seller/products',
    icon: <CategoryOutlinedIcon />,
    label: 'Productos',
    children: [],
  },
];
